import React from 'react';
import { bonuses, type Bonus } from '../data/bonuses';
function BonusCover({
  bonus
}: {
  bonus: Bonus;
}) {
  if (bonus.cover) {
    return <div className="flex h-[300px] items-center justify-center border-b border-plum-line bg-plum-deep py-6 sm:h-[340px]" data-id="element-19" data-mp="pj6cm4pkakr0">
        <img src={bonus.cover} alt={`${bonus.title} cover`} width={768} height={1024} loading="lazy" className="aspect-[3/4] h-full w-auto rounded-md object-cover shadow-cover ring-1 ring-white/10" data-id="element-20" data-mp="at8t422kuj85" />
      </div>;
  }
  return <div aria-hidden="true" className="relative flex h-[230px] items-center justify-center border-b border-plum-line bg-blush sm:h-[265px]" data-id="element-21" data-mp="5tnn57ozpalx">
      <div className="relative w-[62%] max-w-[260px] aspect-[4/3] overflow-hidden rounded-md bg-cream shadow-cover ring-1 ring-black/5" data-id="element-22" data-mp="3t1hjss1yrezj">
        <div className="px-[8%] pt-[8%]" data-id="element-23" data-mp="1m8fgpnxvgnwt">
          <span className="block text-[10px] font-semibold uppercase tracking-[0.18em] text-gold-deep" data-id="element-24" data-mp="1r8a59ku6d1ep">
            Bonus {bonus.number}
          </span>
          <span className="mt-2 block font-display text-[15px] font-semibold leading-tight text-plum sm:text-base" data-id="element-25" data-mp="3ic3iy7ucwyet">
            {bonus.title}
          </span>
        </div>
        <span className="absolute left-[8%] right-[8%] bottom-[20%] h-px bg-gold" data-id="element-26" data-mp="3r68bqwt1wjwz" />
        <span className="absolute bottom-[8%] left-[8%] font-display text-[10px] text-ink-soft" data-id="element-27" data-mp="3n6g36k3nqdrm">
          Wrestling Practice Ready
        </span>
        <span className={`absolute inset-x-0 bottom-0 h-[5%] ${bonus.accent}`} data-id="element-28" data-mp="2ugh92aalvqg3" />
      </div>
    </div>;
}
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="w-full bg-plum" data-id="element-29" data-mp="38hbmj7cighlm">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-30" data-mp="33gntyh8mvspa">
        <div className="text-center" data-id="element-31" data-mp="33jif6azh1hjr">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold" data-id="element-32" data-mp="np8d0ml1hllw">
            Also included at no extra cost
          </p>
          <h2 id="bonuses-heading" className="mt-3 font-display font-semibold text-white text-3xl sm:text-5xl" data-id="element-33" data-mp="iqorgnacybu2">
            Five instant-use <span className="text-gold" data-id="element-34" data-mp="3hgya9amfxium">bonuses</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-white/75" data-id="element-35" data-mp="3ljum8ihh6gpl">
            The volumes give you the season. These five get you running it this
            week, whatever your schedule, gym or style.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-36" data-mp="2ttggxanj2cpj">
          {bonuses.map((bonus, i) => <article key={bonus.number} className={`flex flex-col overflow-hidden rounded-3xl border border-plum-line bg-plum-card ${i === bonuses.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:w-[calc(50%-8px)]' : ''}`} data-id="element-37" data-mp="2xv1uky7vyv0s" data-mpi={i}>
              <BonusCover bonus={bonus} data-id="element-38" data-mp="2a4601tc1plpu" />
              <div className="px-5 pb-6 pt-4" data-id="element-39" data-mp="2f30r1ik62gl1">
                <div className="flex flex-wrap items-center gap-2" data-id="element-40" data-mp="2f1xxt3zdg21y">
                  <span className="text-[11px] font-semibold uppercase tracking-widest text-white/60" data-id="element-41" data-mp="27k9jr2l07qbt">
                    Bonus {bonus.number}
                  </span>
                  <span className="rounded-full bg-gold px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-gold-ink" data-id="element-42" data-mp="1xltwxbt0f384">
                    Free today
                  </span>
                </div>
                <h3 className="mt-2.5 font-display text-xl font-semibold leading-snug text-white" data-id="element-43" data-mp="1olnldvgvgdbl">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-sm text-white/70" data-id="element-44" data-mp="1jt48l0q0dm7u">{bonus.body}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}